/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CTA : SIGN IN : STYLES --------------- ++++++++++ */
export default theme => ({
	signincta: {
		'& .link': {
			color: theme.color.primary.medium.swatch,
			textDecoration: 'underline'
		}
	}
});
